import './Banks.scss'
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Col, Row, Modal, Accordion, Card as CardB } from 'react-bootstrap'
import { Td, Tr } from 'react-super-responsive-table'
import SweetAlert from 'sweetalert-react'
import {
  Title,
  Card,
  FormText,
  Icon,
  Button,
  FormTextField,
  Select,
  Switch,
  Dropdown as DropdownComponent,
  CustomTabs,
  CustomReference,
  ModalTable,
  IconImg,
  TableV2,
  CustomDate,
} from 'src/components'
import CSVLoaderV2, { CATEGORY_UPLOAD } from 'src/components/CSVLoader/CSVLoaderV2'

import {
  faEdit,
  faTrash,
  faPlus,
  faSave,
  faCaretDown,
  faFileExcel,
  faCheck,
  faArrowDown,
  faEye,
} from '@fortawesome/free-solid-svg-icons'

import {
  actionTypes as typeT,
  createAccount,
  deleteAccount,
  getAccountHistory,
  getAccounts,
  getBanks,
  updateAccount,
  createBankOperation,
  revertOperation,
  acceptRetention,
  getExcelMovements,
  acceptMovementRequest,
} from 'src/actions/banks.actions'
import {
  selectCreateAccount,
  selectGetAccounts,
  selectGetBanks,
  selectGetHistory,
  selectUpdateAccount,
  selectCSVResponse,
  selectCreateOperation,
  selectRevertOperation,
  selectRequestAccount,
} from 'src/selectors/banks.selector'

import {
  actionTypes as typesD,
  getDepositsByBank,
  getDepositsAdmin,
  getAssociatedOrders,
} from 'src/actions/deposits.actions'
import {
  selectGetAssociated,
  selectGetCreatedDeposit,
} from 'src/selectors/deposits.selector'

import { formatDateFromMillis, formatNumberWithCommas } from 'src/utils/formatters'

import {
  getPermission,
  selectorGetUsersSubmodule,
  selectCurrentUserRoles,
  isAllowed,
} from 'src/selectors/modules.selector'
import { selectCurrentModule } from 'src/selectors/user.selector'

import { loadingSelector } from 'src/selectors/loading.selector'
import {
  singleErrorSelector,
  handlerError,
  handlerSuccess,
  hasErrorsSelector,
} from 'src/selectors/error.selector'

import { getCompanyUsers as getUsersInSubmodule } from 'src/actions/modules.actions'

import { selectCsvResponse } from 'src/selectors/disbursements.selector'

import BankAccountListModal from './BankAccountListModal'
import DepositPage from 'src/content/Deposits/DepositPage'
import IconButton from 'src/components/buttons/IconButton'
import { onSetModalOrder } from 'src/actions/utilities.actions'
import IconSearch from 'src/assets/v2/icon-search2.svg'

import SimplePurchase from 'src/components/custom/SimplePurchase/SimplePurchase'
import { getAllCurrencies } from 'src/actions/currencies.actions'

import AccreditationMultiple from './AccreditationMultiple'
import { selectCompanyCountry } from 'src/selectors/company.selector'
import { Country } from 'src/enums/countries'
import BankUpCsv from './BankUpCsv'

const Banks = () => {
  const newAccountBase = {
    accountNumber: '',
    name: '',
    toName: '',
    bank: '',
    type: '',
    balance: '',
  }
  const types = [
    { id: 1, label: 'Monetaria' },
    { id: 2, label: 'Ahorro' },
  ]
  const bankImg = [
    '',
    'https://firebasestorage.googleapis.com/v0/b/distribution-app-dev.appspot.com/o/Banks%2F1.png?alt=media&token=5e51f64a-485e-4a01-a41c-468e8cc17d65',
    'https://firebasestorage.googleapis.com/v0/b/distribution-app-dev.appspot.com/o/Banks%2F2.png?alt=media&token=4da6be5a-54d9-41c6-9af2-f013c4d591a5',
    'https://firebasestorage.googleapis.com/v0/b/distribution-app-dev.appspot.com/o/Banks%2F3.png?alt=media&token=27ca0e34-da9c-4f74-a189-872f969b7b1e',
    'https://firebasestorage.googleapis.com/v0/b/distribution-app-dev.appspot.com/o/Banks%2F4.png?alt=media&token=01e7268c-c694-4270-b2b7-368d0e99d241',
  ]
  const operations = [
    { id: 100, label: 'Monto inicial' },
    { id: 101, label: 'Acreditacion' },
    { id: 102, label: 'Retiro' },
  ]
  const [alertForm, setAlertForm] = useState({
    title: '',
    text: '',
    type: 'success',
    show: false,
  })

  const dispatch = useDispatch()
  const [actions, setActions] = useState({
    retention: false,
    multiple: false,
    deposit: false,
    matched: false,
    simples: false,
    movement: false,
    associated: false,
    getBanks: false,
    deleteAccount: false,
  })

  const [modalMultiple, setMultiple] = useState({
    show: false,
    item: {},
    amount: 0,
    purchase: true,
  })

  const allCurrencies = useSelector(state =>
    Object.assign(
      [],
      state.currencies.allCurrencies.map(c => ({ ...c, label: c.code, value: c.id })),
    ),
  )
  const [bankAccount, setBankAccount] = useState({})

  const [modalNew, setModalNew] = useState(false)
  const [modalEdit, setModalEdit] = useState(false)
  const [name, setName] = useState('')
  const [currency, setCurrency] = useState({})
  const [toName, setToName] = useState('')
  const [report, setReport] = useState(null)
  const [newAccount, setNewAccount] = useState({ ...newAccountBase })
  const [pickedAccount] = useState({})
  const [modalList] = useState(false)
  const [csvModal, setCsvModal] = useState({ show: false, response: {} })
  const [, setDeposit] = useState({ item: {}, show: false })
  const [, setDepositChange] = useState({
    status: { value: 100, label: 'Ingresada' },
    message: '',
  })
  const [movementModal, setMovementModal] = useState({ show: false })
  const [movementRequest, setMovementRequest] = useState({ operationType: null })
  const [modalRequest, setModalRequest] = useState(false)

  const [users, setUsers] = useState([])
  const [auths, setAuths] = useState([])
  const [opType, setOpType] = useState({ value: -1, label: 'Todos' })
  const [userSel, setUserSel] = useState({ value: -1, label: 'Todos' })
  const [authSel, setAuthSel] = useState({ value: -1, label: 'Todos' })
  const [selectedMovement, setSelectedMovement] = useState(null)
  const [revert, setRevert] = useState({ id: 0, message: 'Eliminar movimiento' })
  const [customRef, setCustomRef] = useState({
    show: false,
    documentType: 0,
    documentId: 0,
  })
  const [cFilter, setFilter] = useState({
    wRef: true,
    nRef: true,
    deposit: true,
    expense: true,
    purchase: true,
    acredit: true,
    nAcredit: true,
    disbursement: true,
    transfer: true,
    retention: true,
    duplicate: false,
    voucher: true,
  })
  const [group, setGroup] = useState([])
  const [asigned, setAsigned] = useState({ value: null, label: 'no seleccionado' })
  const [accountModule, setAccountModule] = useState({ value: 8000, label: 'Todos' })
  const [showAssociated, setAssociated] = useState(false)

  const [accountToTransfer, setAccountToTransfer] = useState(null)
  const [secondReference, setSecondReference] = useState('')
  const [movementPage, setMovementPage] = useState(0)
  const [receipt, setReceipt] = useState(null)
  const [receiptFilter, setReceiptFilter] = useState(null)
  const [acceptRequest, setAcceptRequest] = useState({ show: false })
  const [, setQuantity] = useState(null)
  const [filterM, setFilterM] = useState({ pending: 0, skip: 0, size: 10, search: '' })
  const [show, setShow] = useState(false)
  const [amount, setAmount] = useState(null)

  const loadingBanks = useSelector(state => loadingSelector([typeT.GET_ACCOUNTS])(state))
  const banks = useSelector(selectGetBanks)
  const country = useSelector(selectCompanyCountry)
  const accounts = useSelector(selectGetAccounts)
  const requestA = useSelector(selectRequestAccount)
  const history = useSelector(selectGetHistory)
  const updated = useSelector(selectUpdateAccount)
  const created = useSelector(selectCreateAccount)
  const module = useSelector(selectCurrentModule)
  const csvResponse2 = useSelector(selectCsvResponse)
  const loadingT = useSelector(state => loadingSelector([typeT.SET_MOVEMENTS_CSV])(state))
  const errorT = useSelector(state =>
    singleErrorSelector([typeT.SET_MOVEMENTS_CSV])(state),
  )
  const csvResponse = useSelector(state => selectCSVResponse(state))
  const associated = useSelector(selectGetAssociated)
  const loadingA = useSelector(state => loadingSelector([typesD.GET_ASSOCIATED])(state))

  const loadingOp = useSelector(state => loadingSelector([typeT.CREATE_OPERATION])(state))
  const hasErrorOp = useSelector(state =>
    hasErrorsSelector([typeT.CREATE_OPERATION])(state),
  )
  const errorOp = useSelector(state =>
    singleErrorSelector([typeT.CREATE_OPERATION])(state),
  )

  const loadingAT = useSelector(state => loadingSelector([typeT.ACCEPT_RETENTION])(state))
  const hasErrorAT = useSelector(state =>
    hasErrorsSelector([typeT.ACCEPT_RETENTION])(state),
  )
  const errorAT = useSelector(state =>
    singleErrorSelector([typeT.ACCEPT_RETENTION])(state),
  )

  const loadingAH = useSelector(state =>
    loadingSelector([typeT.GET_ACCOUNT_HISTORY])(state),
  )

  const loadingEM = useSelector(state => loadingSelector([typeT.EXCEL_MOVEMENTS])(state))
  const hasErrorEM = useSelector(state =>
    hasErrorsSelector([typeT.EXCEL_MOVEMENTS])(state),
  )
  const errorEM = useSelector(state =>
    singleErrorSelector([typeT.EXCEL_MOVEMENTS])(state),
  )

  const deletedAccount = useSelector(state =>
    loadingSelector([typeT.DELETE_ACCOUNT])(state),
  )

  const loadingCreateOrUpdateAccount = useSelector(state =>
    loadingSelector([typeT.CREATE_ACCOUNT, typeT.UPDATE_ACCOUNT])(state),
  )

  //const errorD = useSelector(state => singleErrorSelector([typesD.UPDATE_DEPOSIT])(state));
  const updatedDeposit = useSelector(state => selectGetCreatedDeposit(state))
  const createOperation = useSelector(selectCreateOperation)
  const usersSubmodule = useSelector(state => selectorGetUsersSubmodule(state))

  const AdminAccount = useSelector(state =>
    getPermission(state, module === 1000 ? 6151 : 6201),
  )

  const revertSelector = useSelector(state => selectRevertOperation(state))

  const loadingAR = useSelector(state =>
    loadingSelector([typeT.GET_ACCOUNT_HISTORY])(state),
  )

  const loadingMR = useSelector(state => loadingSelector([typeT.ACCEPT_MOVEMENT])(state))
  const hasErrorMR = useSelector(state =>
    hasErrorsSelector([typeT.ACCEPT_MOVEMENT])(state),
  )

  const [dates, setDates] = useState({ start: null, end: null })

  const roles = useSelector(selectCurrentUserRoles)

  /*Permissions*/
  const create = useSelector(state =>
    isAllowed(state, [6151, 6156, 6201, 6206, 8003, 11750, 11753]),
  )

  const edit = useSelector(state =>
    isAllowed(state, [6151, 6157, 6201, 6207, 8003, 11750, 11754]),
  )

  const operation = useSelector(state =>
    isAllowed(state, [6151, 6153, 6201, 6203, 8003, 11750, 11755]),
  )

  const duplicate = useSelector(state => isAllowed(state, [6151, 6154, 6201, 6204]))

  const request = useSelector(state => isAllowed(state, [6151, 6160]))

  const getCurrencyById = id => allCurrencies.find(c => c.id === id) || {}

  const getCurrencies = () => {
    const currencies = []

    for (const account of accounts) {
      const currency = getCurrencyById(account.currency)
      if (!currencies.find(c => c.id === currency.id)) {
        currencies.push(currency)
      }
    }

    return currencies
  }

  useEffect(() => {
    dispatch(getAllCurrencies())
  }, [])

  useEffect(() => {
    if (
      allCurrencies.length > 0 &&
      country.id === Country.SV &&
      Object.entries(currency).length === 0
    ) {
      setCurrency(getCurrencyById(2))
    }
  }, [allCurrencies])

  useEffect(() => {
    if (loadingAT) setActions({ ...actions, retention: true })
    else if (actions.retention) {
      setSelectedMovement(null)
      if (hasErrorAT)
        setAlertForm({
          ...handlerError(errorAT.message),
          onConfirm: () => setAlertForm({ ...alertForm, show: false }),
        })
      else {
        dispatch(getAccounts())
        getMovementAndDeposit(dates.start, dates.end)
        setAlertForm({
          ...handlerSuccess('Operación exitosa'),
          onConfirm: () => {
            setAlertForm({ ...alertForm, show: false })
          },
        })
      }
    }
  }, [loadingAT])

  useEffect(() => {
    if (loadingA) setActions({ ...actions, associated: true })
    else if (actions.associated) {
      setAssociated(true)
    }
  }, [loadingA])

  useEffect(() => {
    if (!roles || roles.length <= 0) return
    dispatch(getBanks())
    // dispatch(getAccounts({assigned: !getAll ? user.id : null}));
    dispatch(getAccounts(false))
    getUsers()
  }, [roles])

  /*useEffect( () => {
        if(!requestA.id) return;
        setBankAccount(requestA)
        dispatch(getAccountHistory(requestA.id, {pending: true}));
    }, [requestA])*/

  useEffect(() => {
    if (!newAccount.bank) return //error

    setModalNew(false)
    setBankAccount(created)
    setAlertForm({
      type: 'success',
      title: 'Exito',
      text: 'Cuenta Creada',
      show: true,
      onConfirm: () => {
        setAlertForm({ ...alertForm, show: false })
      },
    })
    dispatch(getAccounts())
  }, [created])

  useEffect(() => {
    if (!bankAccount.id) return
    setName(bankAccount.name)
    setToName(bankAccount.toName)
    setCurrency(getCurrencyById(bankAccount.currency))

    // if(bankAccount.currency === 1)
    //     setCurrency({value: 1, label: 'GTQ'})
    // else
    //     setCurrency({value: 2, label: 'USD'})
    if (bankAccount.asigned) {
      setAsigned({
        label: bankAccount.userAsigned ? bankAccount.userAsigned.name : '--',
        value: bankAccount.asigned,
      })
    }
    setReport(bankAccount.report)

    if (bankAccount.id !== 100000000) {
      getMovementAndDeposit(dates.start, dates.end)
    }
  }, [bankAccount])

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      const newRes = []
      accounts.forEach(item => {
        const index = newRes.findIndex(
          r => r.filter(a => a.bank === item.bank).length > 0,
        )
        if (index >= 0) newRes[index].push(item)
        else newRes[newRes.length] = [item]
      })
      setGroup(newRes)
    }
  }, [accounts])

  useEffect(() => {
    if (!name) return //error
    setBankAccount(updated)
    setModalEdit(false)
    dispatch(getAccounts())
    setAlertForm({
      type: 'success',
      title: 'Exito',
      text: 'Cambios guardados',
      show: true,
      onConfirm: () => {
        setAlertForm({ ...alertForm, show: false })
      },
    })
  }, [updated])

  useEffect(() => {
    if (!bankAccount.id) return
    if (deletedAccount) setActions({ ...actions, deleteAccount: true })
    else if (actions.deleteAccount) {
      setActions({ ...actions, deleteAccount: false })
      setBankAccount({})
      dispatch(getAccounts())
      setAlertForm({ ...alertForm, showCancelButton: false })
      setAlertForm({
        type: 'success',
        title: 'Exito',
        text: 'Cuenta Eliminada',
        show: true,
        onConfirm: () => {
          setAlertForm({ ...alertForm, show: false })
        },
      })
    }
  }, [deletedAccount])

  useEffect(() => {
    if (!history || history.size === 0) {
      setQuantity(0)
      return
    }

    let u = []
    let a = []
    history.movements &&
      history.movements.forEach(i => {
        if (i.createdBy) {
          let findUser = u.find(user => user.value === i.createdBy)
          if (!findUser) {
            u.push({ value: i.createdBy, label: i.user })
          }
        }
        if (i.authorizedBy) {
          let findAuth = a.find(user => user.value === i.authorizedBy)
          if (!findAuth) {
            a.push({ value: i.authorizedBy, label: i.auth })
          }
        }
      })
    setUsers([{ value: -1, label: 'Todos' }, ...u])
    setAuths([{ value: -1, label: 'Todos' }, ...a])
  }, [history])

  // CSV
  useEffect(() => {
    if (bankAccount.id) {
      if (csvResponse.ok === undefined) return
      if (csvResponse.ok) {
        dispatch(getAccountHistory(bankAccount.id))
        alertSuccess(csvResponse.message)
      } else
        alertError(
          csvResponse.message,
          setCsvModal({ show: true, response: csvResponse }),
        )
    }
  }, [csvResponse])

  // CSV
  useEffect(() => {
    if (bankAccount.id) {
      if (csvResponse2.ok === undefined) return
      if (csvResponse2.ok) {
        alertSuccess(csvResponse2.message)
      } else
        alertError(
          csvResponse2.message,
          setCsvModal({ show: true, response: csvResponse2 }),
        )
    }
  }, [csvResponse2])

  // CSV ERROR
  useEffect(() => {
    if (errorT.message === '') return
    alertError(errorT.message || 'Ha ocurrido un error inesperado.')
  }, [errorT])

  // Deposit
  /*useEffect(() => {
        if (errorD.message === "") return;
        alertError(errorD.message || 'Ha ocurrido un error inesperado.');
    }, [errorD]);*/

  useEffect(() => {
    if (!actions.deposit || !updatedDeposit.id) return
    setActions({ ...actions, deposit: false })
    setDeposit({ show: false, item: {} })
    setDepositChange({ status: { value: 100, label: 'Ingresada' }, message: '' })
    alertSuccess('Deposito actualizado satisfactoriamente')

    if (bankAccount.id && bankAccount.id === 100000000) dispatch(getDepositsAdmin())
    else dispatch(getDepositsByBank(bankAccount.id))
    dispatch(getAccountHistory(bankAccount.id))
  }, [updatedDeposit])

  useEffect(() => {
    if (createOperation && movementRequest.reference) {
      dispatch(getAccounts())
      setAlertForm({
        type: 'success',
        title: 'Exito',
        text: 'Operacion Creada',
        show: true,
        onConfirm: () => {
          setAlertForm({ ...alertForm, show: false })
          setMovementModal({ show: false })
          setMovementRequest({
            operationType: { value: 102, label: 'Retirar de la cuenta' },
          })
        },
      })
      getMovementAndDeposit(dates.start, dates.end)
    }
  }, [createOperation]) //revertSelector

  useEffect(() => {
    if (revert.id) {
      if (revertSelector.ok === undefined) return
      if (revertSelector.ok) {
        getMovementAndDeposit(dates.start, dates.end)
        alertSuccess(revertSelector.message)
      } else alertError(revertSelector.message)
    }
  }, [revertSelector])

  useEffect(() => {
    if (loadingBanks) setActions({ ...actions, getBanks: true })
    else if (actions.getBanks) {
      setActions({ ...actions, getBanks: false })
      if (bankAccount) {
        let found = banks.find(f => f.id === bankAccount.id)
        if (found) setBankAccount(found)
      }
    }
  }, [loadingBanks])

  useEffect(() => {
    if (Object.keys(bankAccount).length === 0) return
    getMovementAndDeposit(dates.start, dates.end)
  }, [filterM])

  useEffect(() => {
    if (loadingOp) setActions({ ...actions, movement: true })
    else if (actions.movement) {
      setActions({ ...actions, movement: false })
      if (hasErrorOp) {
        if (duplicate) {
          setAlertForm({
            ...handlerError(errorOp.message + '\n ¿Desea duplicarlo?'),
            showCancelButton: true,
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            onConfirm: () => checkMovement(true),
            onCancel: () => setAlertForm({ ...alertForm, show: false }),
          })
        } else {
          setAlertForm({
            ...handlerError(errorOp.message),
            onConfirm: () => setAlertForm({ ...alertForm, show: false }),
          })
        }
      } else {
        closeModal()
        setAlertForm({
          ...handlerSuccess('Operación bancaria agregada satisfactoriamente'),
          onConfirm: () => {
            setAlertForm({ ...alertForm, show: false })
          },
        })
      }
    }
  }, [loadingOp])

  useEffect(() => {
    if (loadingEM) setActions({ ...actions, excel: true })
    else if (actions.excel) {
      setActions({ ...actions, excel: false })
      if (hasErrorEM)
        setAlertForm({
          ...handlerError(errorEM.message),
          onConfirm: () => setAlertForm({ ...alertForm, show: false }),
        })
      else {
        setAlertForm({
          ...handlerSuccess(
            'Se exportaron los movimientos acreditados en las fechas indicadas.',
          ),
          onConfirm: () => setAlertForm({ ...alertForm, show: false }),
        })
      }
    }
  }, [loadingEM])

  useEffect(() => {
    if (loadingMR) setActions({ ...actions, accept: true })
    else if (actions.accept) {
      setActions({ ...actions, accept: false })
      if (hasErrorMR)
        setAlertForm({
          ...handlerError('No se pudo aceptar el movimiento bancario'),
          onConfirm: () => setAlertForm({ ...alertForm, show: false }),
        })
      else {
        dispatch(getAccounts())
        setModalRequest(false)
        setAcceptRequest({ show: false })
        setAlertForm({
          ...handlerSuccess('El movimiento bancario fue aprobado exitosamente'),
          onConfirm: () => setAlertForm({ ...alertForm, show: false }),
        })
      }
    }
  }, [loadingMR])

  const getMovementAndDeposit = (start, end, receipt) => {
    let { pending, skip, size, search } = filterM
    setDates({ start, end })
    let sDate, eDate
    sDate = start ? start.setHours(0, 0, 0, 0).valueOf() : null
    eDate = end ? end.setHours(23, 59, 59, 99).valueOf() : null

    if (!receipt || receipt === '') {
      setReceiptFilter(null)
      setReceipt(null)
      dispatch(
        getAccountHistory(bankAccount.id, {
          start: sDate,
          end: eDate,
          pending,
          skip,
          size,
          search,
          receipt: null,
        }),
      )
    } else
      dispatch(
        getAccountHistory(bankAccount.id, {
          start: null,
          end: null,
          pending,
          skip,
          size,
          search,
          receipt: receipt,
        }),
      )
    //dispatch(getDeposits(module, {userId: null, start: start.valueOf(), end: end.valueOf()}));
  }

  const getUsers = () => {
    let submodule = [6150, 6200, 8003, 11750]
    dispatch(getUsersInSubmodule(submodule))
  }

  const getTotalBalance = (banks, currency) => {
    let total = 0
    banks.filter(f => f.currency === currency).map(p => (total += p.balance))
    return total
  }

  const renderAccountsRow = (item, index) => {
    const isActive = bankAccount.id && item.id === bankAccount.id ? 'active' : ''

    const itemCurrency = getCurrencyById(item.currency)

    return (
      <div>
        <div
          className={`b-user-item ${isActive}`}
          key={`${index}`}
          onClick={() => {
            setBankAccount(item)
          }}>
          <div
            className={'justify-content-start align-items-start bu-en'}
            style={{ textAlign: 'left' }}>
            <div className={`b-user-name ${isActive}`}>{item.name}</div>
            <div className={`b-user-email ${isActive}`}>{`${item.accountNumber} - ${
              item.id === 100000000 ? 'A todos los bancos' : getBank(item.bank, item.bank)
            }`}</div>
            <div className={`b-user-balance-m ${isActive}`}>
              {itemCurrency.symbol}.{formatNumberWithCommas(item.balance)}
            </div>
          </div>
          <div
            className={'d-flex row align-items-center mr-2 bu-b'}
            style={{ textAlign: 'right' }}>
            <div className={`b-user-balance mr-2 ${isActive}`}>
              {`${itemCurrency.symbol}.
                            ${formatNumberWithCommas(item.balance)}`}
            </div>
            {edit && (
              <Td className={'mini'}>
                <Icon
                  color={'gray'}
                  onClick={() => setModalEdit(true)}
                  icon={faEdit}
                  size={'1_5x'}
                  tooltip={'Editar cuenta bancaria'}
                />
              </Td>
            )}
          </div>
        </div>
      </div>
    )
  }

  const seeReference = item => {
    setCustomRef({
      show: true,
      documentType: item.referenceType,
      documentId:
        item.referenceType === 5 || item.referenceType === 3 || item.referenceType === 12
          ? item.id
          : item.refDocument,
    })
  }

  const getReferenceValid = item => {
    return !!(
      item.refDocument &&
      (item.referenceType === 1 ||
        item.referenceType === 3 ||
        item.referenceType === 4 ||
        item.referenceType === 5 ||
        item.referenceType === 6 ||
        item.referenceType === 12)
    )
  }

  const findOperation = id => {
    let found = operations.find(f => f.id === id)
    return found ? found.label : ''
  }

  const getBank = (id, type, name) => {
    let found = banks.find(f => f.id === id)
    return found ? found.name : type === 6 ? 'Retenciones' : name ? name : ''
  }

  const saveAccount = () => {
    if (
      !newAccount.bank ||
      !newAccount.accountNumber ||
      newAccount.accountNumber === '' ||
      (newAccount.balance !== '' && parseFloat(newAccount.balance) < 0) ||
      !newAccount.toName ||
      newAccount.toName === '' ||
      !newAccount.name ||
      newAccount.name === '' ||
      !newAccount.type
    ) {
      //console.log(newAccount);
      setAlertForm({
        type: 'error',
        title: 'Error',
        text: 'Revise los datos obligatorios del formulario',
        show: true,
        onConfirm: () => {
          setAlertForm({ ...alertForm, show: false })
        },
      })
    } else {
      dispatch(
        createAccount(
          newAccount.accountNumber,
          newAccount.name,
          newAccount.toName,
          newAccount.bank.value,
          newAccount.type.id,
          newAccount.balance,
          accountModule.value,
          asigned.value,
          currency.value,
          newAccount.report,
        ),
      )
    }
  }

  const saveEdit = () => {
    if (
      !name ||
      name.length === 0 ||
      !toName ||
      toName.length === 0 ||
      !asigned.value ||
      !accountModule.value
    ) {
      setAlertForm({
        type: 'error',
        title: 'Error',
        text: 'Revise los datos obligatorios del formulario',
        show: true,
        onConfirm: () => {
          setAlertForm({ ...alertForm, show: false })
        },
      })
    } else {
      const requestU = Object.assign(
        {},
        {
          ...bankAccount,
          name,
          toName,
          asigned: asigned.value,
          module: accountModule.value,
          currency: currency.value,
          report: report,
        },
      )
      dispatch(updateAccount(requestU))
    }
  }

  const deleteAccountAction = () => {
    setAlertForm({
      type: 'warning',
      title: 'Advertencia',
      text: 'Desea eliminar esta cuenta?',
      showCancelButton: true,
      show: true,
      onCancel: () => {
        setAlertForm({ ...alertForm, show: false })
      },
      onConfirm: () => {
        dispatch(deleteAccount(bankAccount.id))
      },
    })
  }

  const alertError = (errMsg, onConfirm) =>
    setAlertForm({
      ...handlerError(errMsg),
      onConfirm: () => {
        setAlertForm({ ...alertForm, show: false })
        if (onConfirm !== undefined) onConfirm()
      },
    })

  const alertSuccess = message =>
    setAlertForm({
      ...handlerSuccess(message),
      onConfirm: () => {
        setAlertForm({ ...alertForm, show: false })
      },
    })

  const checkMovement = duplicate => {
    let error = false
    if (!movementRequest) error = true
    if (!movementRequest?.purchase?.nullify)
      if (!movementRequest.amount || movementRequest.amount <= 0) error = true
    if (!movementRequest.reference) error = true
    if (!movementRequest.date) error = true

    if (
      movementRequest.operationType &&
      movementRequest.operationType.value &&
      movementRequest.operationType.value === 103 &&
      (!accountToTransfer.value || !secondReference)
    )
      error = true
    if (
      movementRequest.operationType &&
      movementRequest.operationType.value &&
      movementRequest.operationType.value === 104 &&
      !movementRequest.user
    )
      error = true

    if (error) {
      setAlertForm({
        type: 'warning',
        title: 'Error',
        text: 'Revise los datos obligatorios del formulario',
        show: true,
        onConfirm: () => {
          setAlertForm({ ...alertForm, show: false })
        },
      })
      return
    }

    let request = { ...movementRequest }
    request.operationType = movementRequest.operationType.value
    request.bankAccount = bankAccount.id

    request.secondAccountId = accountToTransfer ? accountToTransfer.value : null
    request.secondReference = secondReference
    request.currency = currency.value
    request.registerDate = movementRequest.date.valueOf()
    if (movementRequest.user) request.userId = movementRequest.user.value
    if (movementRequest.purchase) request.operationType = 105
    dispatch(createBankOperation(request, { duplicate }))
  }

  const getAccountsItems = () => {
    if (module === 11000)
      return [
        {
          balance: 0,
          id: 100000000,
          name: 'Depositos a Cotizap',
          toName: 'Cotizap',
          type: 0,
          accountNumber: '---',
          bank: 0,
          currency: 1,
          asigned: 183,
        },
        ...accounts,
      ]
    else return accounts
  }

  const getAccountsItemsSelector = () => {
    let accountsSelector

    accountsSelector = accounts
      .filter(f => bankAccount.id !== f.id)
      .map(item => {
        return {
          ...item,
          value: item.id,
          label: `${item.name} - No. ${item.accountNumber} (${
            getCurrencyById(item.currency).symbol
          })`,
        }
      })
    return accountsSelector
  }

  const getBalance = acredit => {
    let total = 0
    history.movements &&
      history.movements.forEach(h => {
        let subTotal = parseFloat(h.amount)

        if (acredit == null) total += parseFloat(subTotal)
        else if (acredit && h.refDocument && h.authorizedBy) total += parseFloat(subTotal)
        else if (!acredit && !h.refDocument) total += parseFloat(subTotal)
      })
    return total
  }

  const handleFilter = event => {
    const { name, checked } = event.target
    setFilter({ ...cFilter, [name]: checked })
  }

  const renderFilters = pending => {
    return (
      <Row>
        <Col className={'borderRight'}>
          {!pending && (
            <>
              <FormText
                placeholder={'Buscar...'}
                id={'receipt'}
                label={'Por número de recibo'}
                info={
                  ' Se buscaran todas los movimientos bancarios que esten asociados a los depositos que tengan el número de recibo que se ingresara en este campo.'
                }
                value={receipt || ''}
                onChange={({ target }) => {
                  let { value } = target
                  setReceipt(value)
                }}
                append={
                  <IconImg
                    style={{ padding: '5px' }}
                    icon={IconSearch}
                    tooltip={'Buscar'}
                    onClick={() => {
                      getMovementAndDeposit(null, null, receipt)
                      setReceiptFilter(receipt)
                    }}
                  />
                }
                aPadding
              />
              <Row>
                {bankAccount.id && bankAccount.bankId !== 6 ? (
                  <>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Switch
                        name={'nRef'}
                        checked={cFilter.nRef}
                        onChange={handleFilter}
                        label={' Sin referencia'}
                        info={'Visualiza las transacciones sin No. De boleta'}
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Switch
                        name={'wRef'}
                        checked={cFilter.wRef}
                        onChange={handleFilter}
                        label={' Con referencia'}
                        info={'Visualiza las transacciones con No. De boleta'}
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Switch
                        name={'disbursement'}
                        checked={cFilter.disbursement}
                        onChange={handleFilter}
                        label={' Desembolso'}
                        info={'Visualiza todos los desembolsos'}
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Switch
                        name={'deposit'}
                        checked={cFilter.deposit}
                        onChange={handleFilter}
                        label={' Deposito'}
                        info={'Visualiza todos los depósitos'}
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Switch
                        name={'expense'}
                        checked={cFilter.expense}
                        onChange={handleFilter}
                        label={' Gasto'}
                        info={'Visualiza todos los movimientos de gastos'}
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Switch
                        name={'purchase'}
                        checked={cFilter.purchase}
                        onChange={handleFilter}
                        label={' Compra'}
                        info={'Visualiza las transacciones para compras'}
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Switch
                        name={'transfer'}
                        checked={cFilter.transfer}
                        onChange={handleFilter}
                        label={' Transferencia'}
                        info={'Visualiza las transferencias realizadas '}
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Switch
                        name={'duplicate'}
                        checked={cFilter.duplicate}
                        onChange={handleFilter}
                        label={'Duplicados'}
                        info={'Visualiza las referencias duplicadas'}
                      />
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                      <Switch
                        name={'voucher'}
                        checked={cFilter.voucher}
                        onChange={handleFilter}
                        label={' Generado con Vale'}
                        info={'Visualiza todos los movimientos que provienen de un vale.'}
                      />
                    </Col>
                  </>
                ) : (
                  <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                    <Switch
                      topLabel
                      name={'retention'}
                      checked={cFilter.retention}
                      onChange={handleFilter}
                      label={' Retenciones'}
                      info={'Visualiza todas las retenciones'}
                    />
                  </Col>
                )}
              </Row>
            </>
          )}
          <Row>
            <Col sm={12} md={4}>
              <Select
                label={'Operacion'}
                options={[
                  { value: -1, label: 'Todos' },
                  { value: 101, label: 'Acreditaciones a la cuenta' },
                  { value: 102, label: 'Retiros de la cuenta' },
                ]}
                value={opType}
                onChange={data => {
                  setOpType(data)
                }}
                info={'Tipo de operación'}
              />
            </Col>
            <Col sm={12} md={4}>
              <Select
                label={'Creado por'}
                options={users}
                value={userSel}
                onChange={data => {
                  setUserSel(data)
                }}
                info={'Filtrar por usuario que creo la transacción'}
              />
            </Col>
            <Col sm={12} md={4}>
              <Select
                label={'Autorizado por'}
                options={auths}
                value={authSel}
                onChange={data => {
                  setAuthSel(data)
                }}
                info={'Filtrar por usuario que autorizo la transaccion'}
              />
            </Col>
          </Row>
          <hr />
        </Col>
      </Row>
    )
  }

  const movementRender = pending => {
    const tableHeader = [
      {
        label: 'Fecha',
        show: true,
        type: 'date',
        value: ['registredAt'],
      },
      {
        label: 'Operacion',
        classNameCustom: item =>
          'mini ' + (item.operationType === 101 ? 'debit' : 'credit'),
        show: true,
        type: 'text',
        value: ['operationType'],
        custom: item => findOperation(item.operationType),
      },
      {
        label: 'Referencia',
        show: true,
        type: 'text',
        value: ['reference'],
        custom: item =>
          item.duplicate
            ? `${item.reference || '--'} - (DUPLICADO)`
            : item.reference || '--',
      },
      {
        label: 'Descripcion',
        show: true,
        type: 'text',
        value: ['description'],
        className: 'medium',
      },
    ]
    if (!pending)
      tableHeader.push(
        ...[
          {
            label: 'Antes',
            show: true,
            select: true,
            type: 'number',
            value: [`previousBalance`],
            custom: item =>
              `${getCurrencyById(item.currency)?.symbol}.${formatNumberWithCommas(
                item.previousBalance,
              )}`,
          },
          {
            label: 'Cantidad',
            show: true,
            select: true,
            type: 'number',
            value: [`amount`],
            custom: item =>
              `${getCurrencyById(item.currency)?.symbol}.${formatNumberWithCommas(
                item.amount,
              )}`,
          },
          {
            label: 'Nuevo',
            show: true,
            select: true,
            type: 'number',
            value: [`newBalance`],
            custom: item =>
              `${getCurrencyById(item.currency)?.symbol}.${formatNumberWithCommas(
                item.newBalance,
              )}`,
          },
          { label: 'Autorizado Por', show: true, type: 'text', value: ['auth'] },
        ],
      )
    else
      tableHeader.push({
        label: 'Cantidad',
        show: true,
        select: true,
        type: 'number',
        value: ['amount'],
        custom: item =>
          `${
            getCurrencyById(item.currency !== 0 ? item.currency : bankAccount.currency)
              ?.symbol
          }.${formatNumberWithCommas(item.amount)}`,
      })
    tableHeader.push(
      ...[
        { label: 'Acreditado a', show: true, type: 'text', value: ['user'] },
        {
          config: true,
          show: true,
          label: '',
          className: 'mini',
          custom: item => getActions(item, pending),
        },
      ],
    )

    const tableItems = history && history.movements && history.movements.sort(sortHistory)

    return (
      <div style={{ display: 'contents' }} className={'column'}>
        <TableV2
          customClass={'scrollX'}
          headers={tableHeader}
          items={tableItems || []}
          total={history.size}
          loading={loadingAH}
          // renderRow={(item, index) => renderHistoryRow(item, index, false, pending)} //fecha user, operation amount desc
          onDateChange={(start, end) => getMovementAndDeposit(start, end)}
          handleChange={search =>
            setTimeout(() => {
              setFilterM({ ...filterM, search })
            }, 1000)
          }
          dateFilter
          nullDate
          customFilter={renderFilters(pending)}
          getPagination={(skip, size, search) =>
            setFilterM({ ...filterM, skip, size, search })
          }
          mobileAuto
          storageKey={pending ? 'mPending' : 'mCredit'}
        />
      </div>
    )
  }

  const getActions = (item, pending) => {
    return (
      <DropdownComponent
        loading={loadingAT && item.id === selectedMovement}
        disabled={
          (!getReferenceValid(item) && item.operationType === 100 && !item.refDocument) ||
          (!pending && item.referenceType === 7 && item.anulled)
        }
        items={[
          {
            title: 'Anular retención',
            show: !pending && item.referenceType === 7, //*item.operationType!==100*/,
            action: () => {
              setAlertForm({ ...alertForm, show: false })
              dispatch(acceptRetention(item.id, true))
              setSelectedMovement(item.id)
            },
          },
          {
            title: 'Eliminar',
            show: movementPage === 1,
            action: () => {
              setRevert({ ...revert, id: item.id })
              setAlertForm({
                type: 'warning',
                title: 'Advertencia',
                text: '¿Está seguro de eliminar la operación?',
                showCancelButton: true,
                show: true,
                onCancel: () => {
                  setAlertForm({ ...alertForm, show: false })
                },
                onConfirm: () => {
                  deleteMovement()
                },
              })
            },
          },
          {
            title: 'Aprobar retención',
            show: pending && item.referenceType === 7,
            action: () => {
              setAlertForm({
                show: true,
                type: 'info',
                title: 'Aceptar retención',
                text: '¿Desea aceptar la soliciutd de retención?',
                showCancelButton: true,
                onCancel: () => setAlertForm({ ...alertForm, show: false }),
                onConfirm: () => {
                  setAlertForm({ ...alertForm, show: false })
                  dispatch(acceptRetention(item.id))
                  setSelectedMovement(item.id)
                },
              })
            },
          },
          {
            title: 'Ver referencia',
            show: getReferenceValid(item),
            action: () => seeReference(item),
          },
          {
            title: 'Ver facturas asociadas',
            show: false,
            action: () => dispatch(getAssociatedOrders(item.refDocument)),
          },
          {
            title: 'Acreditar',
            show: item.operationType === 102 && !item.refDocument,
            action: () => {
              setMultiple({
                show: true,
                item,
                amount: 0,
                purchase: true,
              })
            },
          },
        ]}
      />
    )
  }

  const sortHistory = (a, b) => {
    return b.registredAt - a.registredAt
  }

  const deleteMovement = () => {
    dispatch(revertOperation(revert.id, revert.message))
  }

  const closeModal = () => {
    setAccountToTransfer(null)
    setSecondReference(null)
    setShow(false)
    setMovementRequest({ operationType: null })
    setMovementModal({ ...movementModal, show: false })
  }

  return (
    <div>
      <Title title={'Bancos'} />
      <Row>
        <Col xl={4} lg={4} md={12} sm={12} xs={12}>
          <Card title={'Listado de Cuentas'}>
            <label>
              {' '}
              <span style={{ color: 'red', marginRight: 2 }}>* </span> Si desea hacer
              desembolsos, debe de tener una cuenta seleccionada.{' '}
            </label>
            {getCurrencies().map((currency, key) => (
              <h2 className={'title-general'} key={key}>
                Resumen: {currency.symbol}.
                {formatNumberWithCommas(getTotalBalance(getAccountsItems(), currency.id))}
              </h2>
            ))}
            <Accordion>
              {group
                .filter(p => p.length > 0)
                .map((item, index) => (
                  <Accordion.Item eventKey={index} key={index}>
                    <CardB style={{ marginBottom: 2 }}>
                      <Accordion.Button
                        as={CardB.Header}
                        className={'header-pink'}
                        style={{ padding: '10px 5px', cursor: 'pointer' }}
                        eventKey={`${index}`}>
                        <div
                          className={'d-flex'}
                          style={{ justifyContent: 'space-between', width: '100%' }}>
                          <div className={'d-flex justify-content-flex-start'}>
                            {/*TODO*/}
                            <div className={'mt-2 ml-3'}>
                              {getBank(item[0].bank, null, item[0].name)}
                            </div>
                          </div>
                          <div className={'d-flex'}>
                            <Icon
                              size={'1x'}
                              className={'name'}
                              icon={faCaretDown}
                              style={{ color: 'white', marginRight: 10, marginTop: 10 }}
                            />
                          </div>
                        </div>
                      </Accordion.Button>
                      <Accordion.Body eventKey={`${index}`}>
                        <div>
                          <TableV2
                            customClass={'scroll-x-without-height '}
                            hideFilter
                            items={item}
                            renderRow={renderAccountsRow}
                          />
                        </div>
                      </Accordion.Body>
                    </CardB>
                  </Accordion.Item>
                ))}
            </Accordion>
            {create && (
              <Button
                className={'mt-3 big-button'}
                onClick={() => {
                  setNewAccount({ ...newAccountBase, report: true })
                  setModalNew(true)

                  // getUsers();
                }}
                style={{ maxWidth: '100%', marginBottom: '10px' }}>
                Agregar Cuenta
              </Button>
            )}
            {request && (
              <Button
                className={'mt-1 big-button'}
                onClick={() => {
                  if (requestA) {
                    dispatch(getAccountHistory(requestA.id, { pending: true }))
                    setModalRequest(true)
                    setBankAccount({})
                  }
                }}
                style={{ maxWidth: '100%' }}>
                Administrar solicitudes
              </Button>
            )}
          </Card>
        </Col>
        <Col xl={8} lg={8} md={12} sm={12} xs={12}>
          <Card title={'Detalle'} white>
            {bankAccount.id ? (
              <>
                <Row>
                  <Col>
                    <div className="d-flex align-items-center">
                      <img
                        style={{ maxHeight: '150px', maxWidth: '150px' }}
                        src={bankImg[bankAccount.bank]}
                        alt={'cuenta'}
                      />
                      <h2 className={'title-general'}>Cuenta {bankAccount.name}</h2>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div>
                      A Nombre de: <b>{bankAccount.toName}</b>
                    </div>
                    <div>
                      Balance no acreditado:{' '}
                      <b>
                        {currency.symbol}.{formatNumberWithCommas(getBalance(false))}
                      </b>
                    </div>
                    <div>
                      Balance acreditado:{' '}
                      <b>
                        {currency.symbol}.{formatNumberWithCommas(getBalance(true))}
                      </b>
                    </div>
                  </Col>
                </Row>
                {bankAccount.bank !== 6 && (
                  <div>
                    {/*{bankAccount.currency === 1 && (
                      <div
                        style={{ width: '50%', float: 'left', marginTop: '15px' }}
                        className={'column'}>
                        <Switch
                          id={bankAccount.id}
                          checked={bankAccount.id === account}
                          onChange={e => onChangeSwitch(e, bankAccount)}
                          label={'Cuenta para desembolsos'}
                          info={
                            'En esta cuenta se haran los reintegros de los desembolsos. Solo puede seleccionar una cuenta.'
                          }
                        />
                      </div>
                    )}
                    {bankAccount.company === 1 && (
                      <Switch
                        checked={bankAccount.kolo}
                        onChange={({ target }) => {
                          const { checked } = target
                          dispatch(updateKoloValue(bankAccount.id))
                          setBankAccount({ ...bankAccount, kolo: checked })
                        }}
                        label={'Activo para depositos KOLO'}
                        info={'En esta cuenta se haran los depositos de usuarios kolo'}
                      />
                    )}*/}
                    <div>
                      <Row className={'container-buttons'} style={{ paddingTop: 10 }}>
                        {(module === 8000 || module === 11000 || AdminAccount) && (
                          <>
                            <Button onClick={() => setModalEdit(true)}>
                              <Icon tooltip={'Editar'} icon={faEdit} />
                            </Button>
                            <Button
                              variant={'danger'}
                              onClick={() => {
                                deleteAccountAction()
                              }}>
                              <Icon tooltip={'Eliminar'} icon={faTrash} />
                            </Button>
                          </>
                        )}

                        <Button
                          loading={loadingT}
                          variant={'dark'}
                          onClick={() => {
                            if (receiptFilter)
                              dispatch(
                                getExcelMovements(
                                  null,
                                  null,
                                  filterM.pending,
                                  filterM.skip,
                                  filterM.size,
                                  filterM.search,
                                  bankAccount.id,
                                  receiptFilter,
                                ),
                              )
                            else {
                              let sDate = dates.start
                                ? dates.start.setHours(0, 0, 0, 0).valueOf()
                                : null
                              let eDate = dates.end
                                ? dates.end.setHours(23, 59, 59, 59).valueOf()
                                : null
                              dispatch(
                                getExcelMovements(
                                  sDate,
                                  eDate,
                                  filterM.pending,
                                  filterM.skip,
                                  filterM.size,
                                  filterM.search,
                                  bankAccount.id,
                                  null,
                                ),
                              )
                            }
                          }}>
                          <Icon
                            spin={loadingEM}
                            tooltip={'Exportar transacciones'}
                            icon={faFileExcel}
                          />
                        </Button>

                        {operation && (
                          <>
                            <Button
                              variant={'info'}
                              onClick={() => {
                                setMovementModal({ ...movementModal, show: true })
                              }}>
                              <Icon tooltip={'Agregar Operación'} icon={faPlus} />
                            </Button>

                            {bankAccount?.bank <= 3 && (
                              <BankUpCsv
                                bankId={bankAccount.bank}
                                accountId={bankAccount.id}
                                onSuccess={() =>
                                  getMovementAndDeposit(dates.start, dates.end)
                                }
                              />
                              /*<CSVLoaderV2
                                warehouseId={bankAccount?.id}
                                hideTemplate
                                category={
                                  bankAccount.bank === 1
                                    ? CATEGORY_UPLOAD.BI_CSV
                                    : bankAccount.bank === 2
                                    ? CATEGORY_UPLOAD.RURAL_CSV
                                    : bankAccount.bank === 3
                                    ? CATEGORY_UPLOAD.BAM_CSV
                                    : CATEGORY_UPLOAD.GYT_CSV
                                }
                                title={'Operaciones con CSV'}
                                onSuccess={() =>
                                  getMovementAndDeposit(dates.start, dates.end)
                                }
                              />*/
                            )}
                          </>
                        )}
                      </Row>
                    </div>
                  </div>
                )}

                <br />
                <Row style={{ display: 'contents' }}>
                  <CustomTabs
                    noCard
                    ctBank
                    setKey={key => {
                      setMovementPage(parseInt(key))
                      if (key === '0') setFilterM({ ...filterM, pending: false, skip: 0 })
                      else if (key === '1')
                        setFilterM({ ...filterM, pending: true, skip: 0 })
                    }}
                    items={[
                      {
                        title: 'M. Acreditados',
                        info: 'Registro de movimientos bancarios acreditados',
                        component: movementRender(false),
                      },
                      {
                        title: 'M. Pendientes',
                        info: 'Registro de movimientos bancarios pendientes de acreditación',
                        component: movementRender(true),
                      },
                      {
                        show: bankAccount.id > 0,
                        title: 'Solicitudes de depositos',
                        info: 'Solicitudes de depositos',
                        component: (
                          <DepositPage
                            hide={true}
                            admin={bankAccount.kolo}
                            onDateChange={(start, end) => setDates({ start, end })}
                            bank={bankAccount.id}
                            currency={getCurrencyById(bankAccount.currency)}
                          />
                        ),
                      },
                    ]}
                  />
                </Row>
              </>
            ) : (
              <h5>Es necesario seleccionar una cuenta bancaria</h5>
            )}
          </Card>
        </Col>
      </Row>

      <Modal show={modalNew} size={'lg'} centered onHide={() => setModalNew(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Nueva Cuenta </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col xl={6} md={6} xs={12}>
              <FormTextField
                label={'Numero'}
                type={'number'}
                id={'number'}
                placeholder={'Numero'}
                name={'number'}
                value={newAccount.accountNumber}
                onChange={e => {
                  setNewAccount({ ...newAccount, accountNumber: e.target.value })
                }}
                error={''}
                required
              />
            </Col>
            <Col xl={6} md={6} xs={12}>
              <FormTextField
                label={'Alias'}
                type={'text'}
                id={'name'}
                placeholder={'Alias'}
                name={'name'}
                value={newAccount.name}
                onChange={e => {
                  setNewAccount({ ...newAccount, name: e.target.value })
                }}
                error={''}
                required
              />
            </Col>
            <Col xl={6} md={6} xs={12}>
              <FormTextField
                label={'A nombre de '}
                type={'text'}
                id={'toName'}
                placeholder={'Nombre del propietario'}
                name={'toName'}
                value={newAccount.toName}
                onChange={e => {
                  setNewAccount({ ...newAccount, toName: e.target.value })
                }}
                error={''}
                required
              />
            </Col>
            <Col xl={6} md={6} xs={12}>
              <Select
                label={'Banco'}
                options={[{ value: null, label: '- Seleccionar -' }].concat(
                  banks.map(item => {
                    return { label: item.name, value: item.id }
                  }),
                )}
                value={newAccount.bank}
                onChange={data => {
                  setNewAccount({ ...newAccount, bank: data })
                }}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Select
                label={'Tipo'}
                options={types}
                value={newAccount.type}
                onChange={data => {
                  setNewAccount({ ...newAccount, type: data })
                }}
                required
              />
            </Col>
            {country.id === Country.GT && (
              <Col>
                <Select
                  label={'Moneda'}
                  options={allCurrencies}
                  value={currency}
                  onChange={data => {
                    setCurrency(data)
                  }}
                  required
                />
              </Col>
            )}
            <Col>
              <Select
                label={'Modulo'}
                options={[
                  { value: 8000, label: 'Todos' },
                  { value: 1000, label: 'Transportista' },
                  { value: 2000, label: 'Productor' },
                ]}
                value={accountModule}
                onChange={data => {
                  setAccountModule(data)
                  getUsers(data.value, false)
                }}
              />
            </Col>
            <Col>
              <Select
                label={'Encargado'}
                options={usersSubmodule}
                value={asigned}
                onChange={data => {
                  setAsigned(data)
                }}
              />
            </Col>
            <Col>
              <FormTextField
                label={'Balance'}
                type={'number'}
                id={'balance'}
                placeholder={'0.0'}
                name={'balance'}
                value={newAccount.balance}
                onChange={e => {
                  setNewAccount({ ...newAccount, balance: e.target.value })
                }}
                error={''}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Switch
            name={'report'}
            checked={newAccount.report}
            onChange={() => setNewAccount({ ...newAccount, report: !newAccount.report })}
            label={'Afectar reporte patrimonial'}
            info={
              'Al estar activo, toda acreditación bancaria creara un registro en el reporte patrimonial'
            }
            placement={'top'}
          />

          <Button
            onClick={() => {
              saveAccount()
            }}
            loading={loadingCreateOrUpdateAccount}
            style={{ maxWidth: '100%' }}>
            Crear{' '}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={modalEdit} size={'lg'} centered onHide={() => setModalEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Cuenta </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <FormTextField
                label={'Nombre'}
                type={'text'}
                id={'name'}
                placeholder={'Nombre'}
                name={'name'}
                value={name}
                onChange={e => {
                  setName(e.target.value)
                }}
                error={''}
                required
              />
            </Col>
            <Col>
              <FormTextField
                label={'A nombre de '}
                type={'text'}
                id={'toName'}
                placeholder={'Nombre del propietario'}
                name={'toName'}
                value={toName}
                onChange={e => {
                  setToName(e.target.value)
                }}
                error={''}
                required
              />
            </Col>
            <Col>
              <Select
                label={'Encargado'}
                options={usersSubmodule}
                value={asigned}
                onChange={data => {
                  setAsigned(data)
                }}
              />
            </Col>
            <Col>
              <Select
                label={'Modulo'}
                options={[
                  { value: 8000, label: 'Todos' },
                  { value: 1000, label: 'Transportista' },
                  { value: 2000, label: 'Productor' },
                ]}
                value={accountModule}
                onChange={data => {
                  setAccountModule(data)
                }}
              />
            </Col>
            {country.id === Country.GT && (
              <Col>
                <Select
                  label={'Moneda'}
                  options={allCurrencies}
                  value={currency}
                  onChange={data => {
                    setCurrency(data)
                  }}
                />
              </Col>
            )}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Switch
            name={'report'}
            checked={report}
            onChange={() => setReport(!report)}
            label={'Afectar reporte patrimonial'}
            info={
              'Al estar activo, toda acreditación bancaria creara un registro en el reporte patrimonial'
            }
            placement={'top'}
          />
          <Button
            onClick={() => {
              saveEdit()
            }}
            style={{ maxWidth: '100%' }}
            loading={loadingCreateOrUpdateAccount}>
            Guardar{' '}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={csvModal.show}
        size={'lg'}
        centered
        onHide={() => setCsvModal({ show: false, response: {} })}>
        <Modal.Header closeButton>
          <Modal.Title>
            {csvModal.response.message && csvModal.response.message}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Durante la carga se encontraron los siguientes errores o detalles</p>
          <TableV2
            headers={
              csvModal.response.errorColumns
                ? csvModal.response.errorColumns.map(header => {
                    return { label: header, show: true }
                  })
                : []
            }
            items={csvModal.response.errors || []}
          />
          {/* <Table
                        headers={csvModal.response.errorColumns || []}
                        items={csvModal.response.errors || []}
                        renderRow={(item, index) => (
                            <Tr key={index} className={'data'}>
                                <Td className={'name'}>{item.line}</Td>
                                <Td className={'name'}>{item.column}</Td>
                                <Td className={'name'}>{item.error}</Td>
                                <Td className={'name'}>{item.message}</Td>
                            </Tr>
                        )}
                    /> */}
        </Modal.Body>
      </Modal>

      {/*<Modal
                show={deposit.show}
                size={'xl'}
                centered
                onHide={() => {
                    if (!loadingD) {
                        setDeposit({item: {}, show: false});
                        setDepositChange({status: {value: 100, label: 'Ingresada'}, message: ''});
                        setSelectedMovement(null);
                    }
                }}>

                <Modal.Header closeButton>
                    <Modal.Title>Deposito</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <Row><Col/><Col/></Row>
                        <Row>
                            <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                                <Select
                                    required
                                    label={'Estado'}
                                    options={[{value: 101, label: 'Aprobar'}, {value: 102, label: 'Rechazar'}]}
                                    value={depositChange.status}
                                    onChange={(s) => setDepositChange({...depositChange, status: s})}
                                />
                            </Col>
                            <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                                <FormText
                                    label={"Mensaje"}
                                    type={"text"}
                                    id={"message"}
                                    placeholder={"(opcional) pj. aprobado..."}
                                    name={"message"}
                                    prepend={<Icon tooltip={'Mensaje'} icon={faQuoteRight}/>}
                                    value={depositChange.message}
                                    onChange={({target}) => {
                                        const {value} = target;
                                        setDepositChange({...depositChange, message: value});
                                    }}
                                />
                            </Col>
                            <Col xl={12} lg={12} md={12} sm={12} xs={12} className={'column'}>
                                <span><strong>Selecciona un movimiento bancario para la acreditación</strong></span>
                                <Table
                                    headers={['', 'Fecha','Operacion','Referencia','Cantidad','Desc.']}
                                    items={movementByDeposit}
                                    renderRow={(item, i) => renderHistoryRow(item, i, true)}
                                    noItemsLegend={'No se encontraron movimientos bancarios que coinciden con el deposito'}
                                    loading={loadingMD}
                                />
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Row className={'container-buttons'}>
                        <Button
                            loading={loadingD}
                            disabled={depositChange&&depositChange.status&&depositChange.status.value === 100}
                            onClick={() => changeDeposit()}>
                            Guardar
                        </Button>
                    </Row>
                </Modal.Footer>

            </Modal>*/}

      <Modal
        show={movementModal.show && !show}
        size={'lg'}
        centered
        onHide={() => {
          closeModal()
        }}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Operación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <b>
            Cuando agregas una transacción bancaria en este modal, estás indicando que has
            visto una transacción en el estado de cuenta bancario. Esta transacción no
            será acreditada a ningún usuario a menos que un administrador así lo autorice
          </b>
          <Row>
            <Col md={5}>
              <Select
                required
                label={'Tipo'}
                options={[
                  { value: 101, label: 'Acreditar a la cuenta' },
                  { value: 102, label: 'Retirar de la cuenta' },
                  { value: 104, label: 'Transferir a efectivo circulante' },
                  { value: 103, label: 'Transferencia entre cuentas' },
                ].slice(0, accounts.length > 1 ? 4 : 3)}
                value={movementRequest.operationType}
                onChange={s => {
                  setMovementRequest({ ...movementRequest, operationType: s })
                  setAccountToTransfer(null)
                }}
              />
              <Card className={'mt-2 text-center'}>
                <h5 className={'dashboard-currency'} style={{ color: '#226095' }}>
                  {bankAccount.name}
                </h5>
                <h6 className={'dashboard-subtitle dashboard-f-color'}>
                  {`${currency.symbol}.${formatNumberWithCommas(bankAccount.balance)}`}
                </h6>
              </Card>
              {accountToTransfer && accountToTransfer.value && (
                <div style={{ textAlign: 'center' }}>
                  <Icon icon={faArrowDown} size={'1_5x'} />
                  <Card className={'mt-2'}>
                    <h5 className={'dashboard-currency'} style={{ color: '#226095' }}>
                      {accountToTransfer.name}
                    </h5>
                    <h6 className={'dashboard-subtitle dashboard-f-color'}>
                      {`${
                        getCurrencyById(accountToTransfer.currency).symbol
                      }.${formatNumberWithCommas(accountToTransfer.balance)}`}
                    </h6>
                  </Card>
                </div>
              )}
            </Col>
            <Col md={7}>
              <FormTextField
                label={`No. documento${
                  movementRequest.operationType &&
                  movementRequest.operationType.value &&
                  movementRequest.operationType.value === 103
                    ? ' débito'
                    : ''
                }`}
                type={'text'}
                id={'ref'}
                placeholder={'pj. 1535455'}
                name={'ref'}
                value={movementRequest.reference}
                onChange={e => {
                  setMovementRequest({ ...movementRequest, reference: e.target.value })
                }}
                required
              />
              <CustomDate
                label={'Fecha de registro '}
                required
                value={movementRequest.date}
                onDayChange={e => {
                  setMovementRequest({ ...movementRequest, date: e })
                }}
              />
              {movementRequest.operationType &&
                movementRequest.operationType.value &&
                movementRequest.operationType.value === 103 && (
                  <>
                    <Select
                      required
                      label={'Seleccione cuenta a acreditar'}
                      options={getAccountsItemsSelector()}
                      value={accountToTransfer}
                      onChange={s => setAccountToTransfer(s)}
                    />
                    <FormTextField
                      label={'No. documento crédito'}
                      type={'text'}
                      id={'ref'}
                      placeholder={'pj. 1535455'}
                      name={'ref'}
                      value={secondReference}
                      onChange={e => {
                        setSecondReference(e.target.value)
                      }}
                      required
                    />
                    {accountToTransfer &&
                      accountToTransfer.currency !== currency.value && (
                        <FormTextField
                          label={'Tasa de conversión'}
                          type={'number'}
                          id={'amount'}
                          placeholder={'0.00'}
                          name={'change'}
                          value={movementRequest.change}
                          onChange={e => {
                            setMovementRequest({
                              ...movementRequest,
                              change: e.target.value,
                            })
                          }}
                          prepend={currency.symbol}
                          required
                        />
                      )}
                  </>
                )}

              {movementRequest.operationType &&
                movementRequest.operationType.value &&
                movementRequest.operationType.value === 104 && (
                  <Select
                    required
                    label={'Seleccione al usuario a acreditar'}
                    options={usersSubmodule}
                    value={movementRequest.user}
                    onChange={s => setMovementRequest({ ...movementRequest, user: s })}
                  />
                )}

              <FormTextField
                label={'Monto'}
                type={'number'}
                id={'amount'}
                placeholder={'0.00'}
                name={'amount'}
                value={movementRequest.amount}
                onChange={e => {
                  setMovementRequest({ ...movementRequest, amount: e.target.value })
                }}
                error={''}
                inputClassName={
                  movementRequest.operationType &&
                  movementRequest.operationType.value &&
                  movementRequest.operationType.value === 101
                    ? 'debit'
                    : 'credit'
                }
                prepend={currency.symbol}
                required
              />

              <FormTextField
                label={'Descripcion'}
                type={'text'}
                id={'desc'}
                name={'desc'}
                value={movementRequest.description}
                onChange={e => {
                  setMovementRequest({ ...movementRequest, description: e.target.value })
                }}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {movementRequest.operationType &&
            movementRequest.operationType.value === 102 && (
              <Button
                disabled={
                  !movementRequest.reference ||
                  !movementRequest.amount ||
                  !movementRequest.date
                }
                onClick={() => {
                  setShow(true)
                  setAmount(movementRequest.amount)
                }}
                color={'secondary'}>
                Asociar un gasto
              </Button>
            )}
          <Button
            disabled={
              !movementRequest ||
              (!movementRequest.operationType && movementRequest.amount <= 0) ||
              !movementRequest.date ||
              (accountToTransfer &&
                accountToTransfer.currency !== currency.value &&
                !movementRequest.change)
            }
            onClick={() => checkMovement(false)}
            loading={loadingOp}>
            Agregar
          </Button>
        </Modal.Footer>
      </Modal>

      {/*
      <Modal
        show={modalMultiple.show}
        centered
        size={'lg'}
        onHide={() => setMultiple({ ...modalMultiple, show: false })}>
        <Modal.Header closeButton>
          <Modal.Title>Movimiento bancario {modalMultiple.item.reference}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col xl={12} md={12} sm={12}>
              <div>
                <h6>
                  Es necesario seleccionar{' '}
                  {modalMultiple.document.value === 1
                    ? 'compras'
                    : modalMultiple.document.value === 1
                    ? 'gastos'
                    : 'notas de crédito'}{' '}
                  a acreditar
                </h6>
              </div>
            </Col>
            <Col xl={4} md={6} sm={12}>
              <FormText
                label={'Saldo disponible para acreditación'}
                prepend={currency.symbol}
                value={Math.abs(getAmount(modalMultiple.item.amount, null, true))}
                disabled
                onChange={() => undefined}
              />
            </Col>
            <Col xl={12} md={12} sm={12}>
              <Row>
                <Col xs={12} lg={12} md={12}>
                  <h6>Por tipo de documento</h6>
                </Col>
                <Col xs={4} lg={4} md={6} sm={6}>
                  <Select
                    required
                    label={'Tipo de documento'}
                    options={[
                      { value: 1, label: 'Compras' },
                      { value: 2, label: 'Gastos' },
                      { value: 3, label: 'Notas de crédito' },
                    ]}
                    value={modalMultiple.document}
                    onChange={s => setMultiple({ ...modalMultiple, document: s })}
                  />
                </Col>
              </Row>
            </Col>
            <Col xl={12} md={12} sm={12}>
              <TableV2
                storageKey={
                  modalMultiple.document.value === 1
                    ? `banks-1`
                    : modalMultiple.document.value === 2
                    ? `banks-2`
                    : `banks-4`
                }
                noItemsLegend={`No se encontraron ${
                  modalMultiple.purchase ? 'compras' : 'gastos'
                } con los filtros aplicados`}
                footerText={`Saldo acreditado: Q.${formatNumberWithCommas(getAmount())}`}
                items={simples.filter(
                  item =>
                    (modalMultiple.document.value === 1 && item.type !== 3) ||
                    (modalMultiple.document.value === 2 && item.type === 3) ||
                    (modalMultiple.document.value === 3 && item.type === 4),
                )}
                loading={loadingP}
                headers={getHeaders()}
                onClickTr={(e, item) => {
                  if (!(getAmount(modalMultiple.item.amount, item) > 0 && !item.selected))
                    addOrRemove(item)
                }}
                mobileAuto={true}
              />
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Row className={'container-buttons'}>
            <Button
              variant={'info'}
              loading={loadingAM}
              disabled={getAmount(modalMultiple.item.amount) !== 0}
              icon={faSave}
              onClick={() => {
                const purchases = simples
                  .filter(
                    s =>
                      s.selected &&
                      ((modalMultiple.document.value === 1 && s.type !== 3) ||
                        (modalMultiple.document.value === 2 && s.type === 3) ||
                        s.type === 4),
                  )
                  .map(s => ({
                    purchaseId: s.id,
                    amount: s.status === 1 ? s.total : s.balance,
                    creditNote: s.type === 4,
                  }))

                dispatch(accreditMultipleByMovement(modalMultiple.item.id, purchases))
              }}>
              Guardar
            </Button>
          </Row>
        </Modal.Footer>
      </Modal>

      */}

      <BankAccountListModal showModal={modalList} selected={pickedAccount} />

      <CustomReference
        show={customRef.show}
        documentModule={1}
        documentType={customRef.documentType}
        documentId={customRef.documentId}
        onHide={() => setCustomRef({ ...customRef, show: false })}
      />

      <ModalTable
        show={showAssociated}
        items={associated}
        loading={loadingA}
        title={'Facturas asociadas'}
        onHide={() => setAssociated(false)}
        size={'lg'}
        headers={[
          { label: 'No', show: true, value: ['number'], type: 'text', className: 'mini' },
          {
            label: 'Responsable',
            show: true,
            value: ['user'],
            type: 'text',
            className: 'mini',
          },
          {
            label: 'Cliente',
            show: true,
            value: ['name'],
            type: 'text',
            className: 'mini',
          },
          { label: 'Nit', show: true, value: ['nit'], type: 'text', className: 'mini' },
          {
            label: 'Total',
            show: true,
            value: ['total'],
            type: 'currency',
            className: 'mini',
          },
          {
            config: true,
            show: true,
            label: '',
            className: 'mini center',
            custom: item => (
              <IconButton
                icon={faEye}
                size={'md'}
                onClick={() => dispatch(onSetModalOrder(item.order))}
              />
            ),
          },
        ]}
      />

      <ModalTable
        show={modalRequest}
        items={history.movements || []}
        total={history.size}
        loading={loadingAR}
        title={'Solicitudes de movimientos'}
        onHide={() => setModalRequest(false)}
        size={'lg'}
        headers={[
          'Fecha',
          'Referencia',
          'Encargado',
          `Total (${currency.symbol})`,
          'Acciones',
        ]}
        renderRow={(item, index) => (
          <Tr className={'data'} key={`${index}`}>
            <Td className={'name center'}>{formatDateFromMillis(item.createdAt)}</Td>
            <Td className={'name center'}>{item.reference}</Td>
            <Td className={'name center'}>
              {usersSubmodule.filter(i => i.value === item.createdBy)[0].label ||
                'Desconocido'}
            </Td>
            <Td className={'name'}>{formatNumberWithCommas(item.amount)}</Td>
            <Td className={'mini'}>
              <IconButton
                icon={faCheck}
                tooltip={'Aceptar movimiento'}
                style={{ marginRight: 4 }}
                onClick={() => {
                  setAcceptRequest({ show: true, item: item })
                }}
              />
            </Td>
          </Tr>
        )}
      />

      <Modal
        show={acceptRequest.show}
        centered
        size={'md'}
        onHide={() => setAcceptRequest({ ...acceptRequest, show: false })}>
        <Modal.Header closeButton>
          <Modal.Title>Aceptar movimientos bancarios</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
            <FormTextField
              label={`No. documento`}
              type={'text'}
              id={'ref'}
              placeholder={'pj. 1535455'}
              name={'ref'}
              value={acceptRequest.number}
              onChange={({ target }) => {
                let { value } = target
                setAcceptRequest({ ...acceptRequest, number: value })
              }}
              required
            />
          </Col>
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
            <Select
              required
              label={'Seleccione cuenta a acreditar'}
              options={getAccountsItemsSelector()}
              value={acceptRequest.account}
              onChange={s => setAcceptRequest({ ...acceptRequest, account: s })}
            />
          </Col>
          <Col xl={12} lg={12} md={12} sm={12} xs={12}>
            <FormTextField
              label={'Descripcion'}
              type={'text'}
              id={'desc'}
              name={'desc'}
              value={acceptRequest.description}
              onChange={({ target }) => {
                let { value } = target
                setAcceptRequest({ ...acceptRequest, description: value })
              }}
            />
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Row className={'container-buttons'}>
            <Button
              variant={'info'}
              icon={faSave}
              loading={loadingMR}
              disabled={!acceptRequest.number || !acceptRequest.account}
              onClick={() => {
                let object = {
                  accountId: acceptRequest.account.id,
                  number: acceptRequest.number,
                  movementId: acceptRequest.item.id,
                  description: acceptRequest.description ? acceptRequest.description : '',
                }
                dispatch(acceptMovementRequest(object))
              }}>
              Guardar
            </Button>
          </Row>
        </Modal.Footer>
      </Modal>

      {show && (
        <SimplePurchase
          modal
          purchase={false}
          amount={amount}
          onHide={() => closeModal()}
          onCancel={() => setMovementModal({ ...movementModal, show: true })}
          show={show}
          load={loadingOp}
          bank
          onSave={request => {
            movementRequest.purchase = request
            setMovementRequest({ ...movementRequest })
            checkMovement(false)
          }}
        />
      )}

      <AccreditationMultiple
        {...modalMultiple}
        show={modalMultiple.show}
        onHide={success => {
          setMultiple({ ...modalMultiple, show: false })
          if (success) {
            getMovementAndDeposit(dates.start, dates.end)
            dispatch(getAccounts(false))
          }
        }}
      />

      <SweetAlert {...alertForm} />
    </div>
  )
}

export default Banks
